import * as z from "zod";

import {
  TABLE_ACCESSOR_BRAND_NAME,
  TABLE_ACCESSOR_CREATED_AT,
  TABLE_ACCESSOR_ID,
  TABLE_ACCESSOR_IS_RESHIP,
  TABLE_ACCESSOR_RECIPIENT_NAME,
  TABLE_ACCESSOR_SHIPPING_STATUS,
} from "~/components/common/orders/order-list";
import {
  OrderTagClaim,
  OrderTagClaimReason,
  OrderTagFulfillment,
  OrderTagRefund,
  OrderTagReship,
  OrderTagReturn,
  OrderTagShipment,
  OrderTagStatus,
} from "~/graphql/graphql.gen";
import { dateFilterSchema } from "~/validators/date-filter-validator";

export const CREATED_AT_ASC = "created-at-asc";
export const CREATED_AT_DESC = "created-at-desc";

export const DISPLAYED_PROPERTIES_BRAND_NAME = TABLE_ACCESSOR_BRAND_NAME;
export const DISPLAYED_PROPERTIES_CREATED_AT = TABLE_ACCESSOR_CREATED_AT;
export const DISPLAYED_PROPERTIES_ID = TABLE_ACCESSOR_ID;
export const DISPLAYED_PROPERTIES_IS_RESHIP = TABLE_ACCESSOR_IS_RESHIP;
export const DISPLAYED_PROPERTIES_RECIPIENT_NAME =
  TABLE_ACCESSOR_RECIPIENT_NAME;
export const DISPLAYED_PROPERTIES_SHIPPING_STATUS =
  TABLE_ACCESSOR_SHIPPING_STATUS;

const sortOrdersQueryParamValues = [CREATED_AT_ASC, CREATED_AT_DESC] as const;

export const DEFAULT_SORT = CREATED_AT_DESC;

export const DEFAULT_DISPLAYED_PROPERTIES = {
  brandName: true,
  createdAt: true,
  id: true,
  isReship: true,
  recipientName: true,
  shippingStatus: true,
};

export type DisplayedPropertiesKeys = keyof typeof DEFAULT_DISPLAYED_PROPERTIES;

// Mapped to supported operators in orders-filters
const multiselectStringField = z.discriminatedUnion("operator", [
  z.object({
    operator: z.literal("is"),
    value: z.string().array(),
  }),
]);
const multiselectEnumField = <const T extends z.core.util.EnumLike>(
  values: T,
) =>
  z.discriminatedUnion("operator", [
    z.object({
      operator: z.literal("is"),
      value: z.enum(values).array(),
    }),
  ]);

export const searchOrdersQueryParamsSchema = z.object({
  filters: z
    .object({
      brandId: multiselectStringField.optional(),
      claimReason: multiselectEnumField(OrderTagClaimReason).optional(),
      claimStatus: multiselectEnumField(OrderTagClaim).optional(),
      createdAt: dateFilterSchema.optional(),
      fulfillmentStatus: multiselectEnumField(OrderTagFulfillment).optional(),
      itemReference: multiselectStringField.optional(),
      saleId: multiselectStringField.optional(),
      refundStatus: multiselectEnumField(OrderTagRefund).optional(),
      reshipStatus: multiselectEnumField(OrderTagReship).optional(),
      returnStatus: multiselectEnumField(OrderTagReturn).optional(),
      orderId: multiselectStringField.optional(),
      shippingStatus: multiselectEnumField(OrderTagShipment).optional(),
      status: multiselectEnumField(OrderTagStatus).optional(),
    })
    .optional(),
  sort: z.enum(sortOrdersQueryParamValues).catch(DEFAULT_SORT),
  displayedProperties: z
    .object({
      brandName: z.boolean(),
      createdAt: z.boolean(),
      id: z.boolean(),
      isReship: z.boolean(),
      recipientName: z.boolean(),
      shippingStatus: z.boolean(),
    })
    .catch(DEFAULT_DISPLAYED_PROPERTIES),
});

export type SearchOrderQueryParams = z.infer<
  typeof searchOrdersQueryParamsSchema
>;
